function focusOnElement(elem) {
    if (elem instanceof HTMLElement) {
        elem.focus();
    }
}
export function modalAction(node, options) {
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    function onTransitionEnd(e) {
        const node = e.target;
        node.focus();
    }
    function onKeyDown(e) {
        if (e.key === 'Escape' && (options === null || options === void 0 ? void 0 : options.close)) {
            options.close();
            e.stopPropagation();
        }
    }
    node.addEventListener('transitionend', onTransitionEnd);
    node.addEventListener('keydown', onKeyDown);
    focusOnElement(options === null || options === void 0 ? void 0 : options.focusElem);
    return {
        destroy: () => {
            document.body.style.overflow = originalOverflow;
            focusOnElement(options.originalFocusElem);
            node.removeEventListener('transitionend', onTransitionEnd);
            node.removeEventListener('keydown', onKeyDown);
        }
    };
}
